import { render } from "./vprintresources.vue?vue&type=template&id=091b5ce5&scoped=true"
import script from "./vprintresources.vue?vue&type=script&lang=js"
export * from "./vprintresources.vue?vue&type=script&lang=js"

import "./vprintresources.vue?vue&type=style&index=0&id=091b5ce5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091b5ce5"]])

export default __exports__